var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.img}})]),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v("\r\n        "+_vm._s(_vm.title)+"\r\n    ")]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a35217e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Card.vue
// module id = null
// module chunks = 